var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPadlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 19,
  viewBox: "0 0 15 19"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 6h15v2H0zm0 11h15v2H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 6h2v13H0zm13 0h2v13h-2zM3 4h2v3H3zm7 0h2v3h-2z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M11 4.5a3.5 3.5 0 0 0-7 0"
}))));
export default SvgPadlock;